<script>
  export let content = '';
</script>

<div class="container">
  <div class="icon-wrapper">
    <svg xmlns="http://www.w3.org/2000/svg" width="87" height="83" viewBox="0 0 87 83" fill="none">
      <g clip-path="url(#clip0_509_43)">
        <mask
          id="mask0_509_43"
          style="mask-type:luminance"
          maskUnits="userSpaceOnUse"
          x="1"
          y="1"
          width="84"
          height="80"
        >
          <path
            d="M39.6605 3.10938L29.6039 23.3573C29.0568 24.4624 28.0002 25.2304 26.7738 25.3989L4.30214 28.6393C1.22668 29.0889 -0.0186005 32.8725 2.22668 35.0265L18.453 50.7416C19.3398 51.6032 19.7549 52.8394 19.5285 54.0569L15.6983 76.2528C15.17 79.3059 18.3776 81.6473 21.1323 80.205L41.2643 69.6971C42.3586 69.1351 43.6605 69.1351 44.736 69.6971L64.868 80.205C67.6227 81.6473 70.8302 79.3059 70.3019 76.2528L66.4717 54.0569C66.2642 52.8394 66.6604 51.5845 67.5661 50.7416L83.7924 35.0265C86.0377 32.8538 84.7924 29.0702 81.717 28.6393L59.2454 25.3989C58.0189 25.2304 56.9623 24.4624 56.4152 23.3573L46.3963 3.10938C45.6982 1.72331 44.3775 1.03027 43.0379 1.03027C41.6982 1.03027 40.3775 1.72331 39.6794 3.10938"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_509_43)">
          <path
            d="M86.0562 1.03027H-0.00012207V81.666H86.0562V1.03027Z"
            fill="url(#paint0_linear_509_43)"
          />
        </g>
        <mask
          id="mask1_509_43"
          style="mask-type:luminance"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="86"
          height="82"
        >
          <path d="M86 0H0.0568848V81.6847H86V0Z" fill="white" />
        </mask>
        <g mask="url(#mask1_509_43)">
          <path
            d="M39.6606 3.10938C41.038 0.337237 45.0002 0.337237 46.3776 3.10938L56.4342 23.3573C56.9813 24.4624 58.0379 25.2304 59.2644 25.3989L81.736 28.6393C84.8114 29.0889 86.0378 32.8725 83.8114 35.0265L67.5851 50.7416C66.6983 51.6032 66.2832 52.8394 66.4907 54.0569L70.3209 76.2528C70.8492 79.3059 67.6417 81.6473 64.887 80.205L44.755 69.6971C43.6606 69.1352 42.3587 69.1352 41.2833 69.6971L21.1513 80.205C18.3966 81.6473 15.189 79.3059 15.7173 76.2528L19.5475 54.0569C19.755 52.8394 19.3588 51.5845 18.4532 50.7416L2.24568 35.0265C0.000399291 32.8725 1.22681 29.0889 4.32114 28.6393L26.7928 25.3989C28.0192 25.2304 29.0758 24.4624 29.6229 23.3573L39.6606 3.10938Z"
            stroke="white"
            stroke-width="2.9951"
            stroke-miterlimit="10"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_509_43"
          x1="42.2775"
          y1="83.0388"
          x2="42.2775"
          y2="1.35413"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="var(--COR_MOD_TER)" />
          <stop offset="1" stop-color="var(--COR_MOD_PRI)" />
        </linearGradient>
        <clipPath id="clip0_509_43">
          <rect width="86.2827" height="82.174" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </div>
  <div class="titulo">
    <h2><i>BOAS <b>PRÁTICAS</b></i></h2>
  </div>
  <div class="box-texto">
    {content}
  </div>
</div>

<style>
  .container {
    --Principais-Roxo-azul: #8421e9;
    --transparentes-roxo-10: rgba(132, 33, 233, 0.1);
    --cor-primaria: #b62ca2;
    --cor-secundaria: #33cfb9;

    position: relative;
    margin-top: 16px;
    /*margin-bottom: 30px;*/
  }

  .icon-wrapper {
    position: absolute;
    top: -16px;
    /* transform: translateY(-15%); */
    left: -32px;
    z-index: 10;
    /* display: flex; */
    /* align-items: center; */
    /* justify-content: center; */
  }

  .icon-wrapper svg {
    /* width: 68px; */
    /* height: 72px; */
  }

  .box-texto {
    width: 100%;
    height: auto;

    color: var(--COR_MOD_PRI_BOAS_1);
    font-family: 'Inter';
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 26px;

    border-radius: 0 35px 35px 35px;
    padding: 25px 30px 25px 29px;
    white-space: pre-wrap;
    word-break: break-word;

    border: 2px solid var(--COR_MOD_PRI_BOAS_1);
    background-color: var(--COR_MOD_PRI_BOAS_2);

    background-origin: border-box;
    background-clip: padding-box, border-box;
  }
  .titulo {
    width: fit-content;
    background-color: var(--COR_MOD_PRI_BOAS_1);
    padding: 6px 15px 6px 60px;
    border-radius: 12.7px 8.7px 8.7px 0px;
  }

  .titulo h2 {
    color: var(--Principais-Branco, #fff);
    font-family: var(--FONT_ARCHI);
    font-size: 24px;
    font-style: italic;
    font-weight: 400;
    line-height: normal;
    text-transform: uppercase;
    margin-bottom: 0em;
  }

  @media (max-width: 800px) {
    .icon-wrapper {
      top: -1px;
      transform: translateY(0px);
      left: 5px;
    }

    .icon-wrapper svg {
      width: 50px;
      height: unset;
    }
    .titulo {
      padding: 7px 15px 7px 50px;
      border-radius: 28px 8.7px 8.7px 0px;
      top: 18px;
      position: relative;
    }
    .box-texto {
      padding: 20px 20px 15px 20px;
      margin-top: 18px;
    }
  }
</style>
